import { reactive } from 'vue';
import Vue from 'vue';
import axios from "axios"
import { session } from '@/js/session';
import {stopRecording} from '@/js/examRecord';
export const exam = reactive({
    currentAnswerChekedId: {},
    score: 0,
    examQuestions: [],
    startExam: false,
    exam: null,
    fullExams: null,
    noExamRzv: false,
    examEnded: false,
    examStarted: false,
    data: null,
    srcImg: null,
    options: null,
    loading: true,
    currentQuestion: 0,
    prevQuestId: 0,
    examStatus: null,
    timer: null,
    obs: null,
    refreshed: false,
    countDown: null,
    startDate: new Date(),
    parent: null,
    currentExamIndex: 0,
    results: {},
    fullExam : false,
    errorSaveQuestions:[],
    restartExam() {
        this.clearSessionStorage();
        this.examEnded = false;
        this.startExam = false;
        this.prevQuestId = 0;
        this.currentExamIndex = 0;
    },
    refreshBtns(activate) {
        let skipbtn = document.getElementById("skipbtn");
        let sumbtn = document.getElementById("sumbtn");
        if (skipbtn != null)
            skipbtn.disabled = activate;

        if (sumbtn != null)
            sumbtn.disabled = activate;

    },

    async getPrevQuestion(examQuestion) {
        this.loading = true;
        this.refreshBtns(true);
        let prevAnswerChecked = true;
        if(this.fullExam){
            prevAnswerChecked = questionIndexToReturn < 0 ||
            ( this.currentAnswerChekedId[examQuestion.id] && this.currentAnswerChekedId[examQuestion.id].length > 0);
        }
        else { 
            prevAnswerChecked = !this.data || !this.data.exam
            || !this.data.exam.questionDisplayCount
            || this.data.exam.questionDisplayCount == 0
            || (this.currentAnswerChekedId[examQuestion.id] && this.currentAnswerChekedId[examQuestion.id].length > 0)
            //when we have not other prev question 
            || this.prevQuestId==0;
        }
        let canContinue = true;
        if (!prevAnswerChecked) {
            let confirmText = "noAnswerOnPrevQuestion";
            if (this.parent) {
                confirmText = this.parent.$t(confirmText);
            }
            canContinue = await this.getConfirmation(confirmText);
        }

        if (canContinue) {
            const params = {
                prevQuestId: this.prevQuestId,
                examId: sessionStorage.getItem("ExamId"),
                currentAnswerChekedIds: this.currentAnswerChekedId[examQuestion.id],
                index: this.data?.index,
                user: null,
                isSkiped: false,
                clientTime: new Date().toJSON(),
                timeElapsed: this.startDate ? ((new Date() - this.startDate)/1000) | 0 : 0,
                haveAnyAnswer: this.currentAnswerChekedId[examQuestion.id] != null ? this.currentAnswerChekedId[examQuestion.id].length > 0 : false
            };
            try {
                let res = await axios({ async: true, crossDomain: true, url: process.env.VUE_APP_ROOT_API + 'examBack/', method: 'put', data: params });
                await  this.afterExamCall(res);
            }

            catch (error) {
                this.loading=false;
                this.clearSessionStorage();
            }
        }else{
            this.loading = false;
        }

    },

    async getConfirmation(text){
        const confirmed = await Vue.prototype.$confirmDialog({
            title: '',
            text: text
            });

        return confirmed;
    },
    questions() {
        if(this.fullExam){
            return this.fullExams.fullGroupExams[this.currentExamIndex].examQuestions;
        }else{
            return [this.data]
        }
    },

    async getNextQuestion(examQuestion, questionIndexToReturn, isSkiped, retry = true, timedOut = false, firstCall = false) {
        if (this.examEnded)
            this.restartExam();
        this.loading = true;
        this.refreshBtns(true);
        let prevAnswerChecked = true;
        if(this.fullExam){
            prevAnswerChecked = questionIndexToReturn < 0 ||
            ( this.currentAnswerChekedId[examQuestion.id] && this.currentAnswerChekedId[examQuestion.id].length > 0);
        }
        else { 
            prevAnswerChecked = !this.data || !this.data.exam
            || !this.data.exam.questionDisplayCount
            || this.data.exam.questionDisplayCount == 0
            || (this.currentAnswerChekedId[examQuestion.id] && this.currentAnswerChekedId[examQuestion.id].length > 0)
            //when we have not other prev question 
            || this.prevQuestId==0;
        }
        let canContinue = true;
        if (!prevAnswerChecked && !timedOut) {
            let confirmText = "noAnswerOnPrevQuestion";
            if (this.parent) {
                confirmText = this.parent.$t(confirmText);
            }
            canContinue = await this.getConfirmation(confirmText);
        }

        if (canContinue) {
            const params = {
                prevQuestId: this.fullExam && !firstCall ? examQuestion.question.id : this.prevQuestId,
                examId: this.fullExam ? examQuestion.exam.id : sessionStorage.getItem("ExamId"),
                currentAnswerChekedIds: this.currentAnswerChekedId[examQuestion.id],
                user: null,
                index: this.fullExam ? examQuestion.index : this.data?.index,
                isSkiped: isSkiped,
                clientTime: new Date().toJSON(),
                timeElapsed: this.startDate ? ((new Date() - this.startDate) / 1000) | 0 : 0,
                haveAnyAnswer: this.currentAnswerChekedId[examQuestion.id] != null ? this.currentAnswerChekedId[examQuestion.id].length > 0 : false
            };

            try {
                let endPoint = "examNext/";
                if (questionIndexToReturn > 0) {
                    endPoint = "examQuestion/";
                }
                let res = await axios({ 
                      async: true,
                      crossDomain: true,
                      url: process.env.VUE_APP_ROOT_API + endPoint,
                      method: 'put', params: { questionIndex: questionIndexToReturn },
                      data: params });
              
                const errorIndex = this.errorSaveQuestions.indexOf(examQuestion.index);
                if (errorIndex !== -1) {
                    this.errorSaveQuestions.splice(errorIndex, 1);
                }
                await this.afterExamCall(res);

            }
            catch (error) {
                const errorIndex = this.errorSaveQuestions.indexOf(examQuestion.index);
                if (errorIndex == -1) {
                    this.errorSaveQuestions.push(examQuestion.index);
                }
                if (retry) {
                    await new Promise(r => setTimeout(r, 500));
                    await this.getNextQuestion(examQuestion,questionIndexToReturn, isSkiped, false, timedOut, firstCall);
                }
                else {
                    this.loading=false;
                    this.clearSessionStorage();
                }
            }
        } else {
            setTimeout(() => { this.loading = false; }, 100);
        }
    },
    getQuestImage(questionAttachment) {
        if (questionAttachment != null) {
            return '/img/quest/' + questionAttachment.name;
        }
    },
    getAnsImage(answerAttachment) {
        if (answerAttachment != null) {
            return '/img/ans/' + answerAttachment.name;
        }
    },
    async fetchResults() {
        for (const e of (this.exam.groupExams ?this.exam.groupExams : exam.exam.fullGroupExams) ) {
            this.loading = true;
            let res2 = await axios({ "async": true, "crossDomain": true, url: process.env.VUE_APP_ROOT_API + 'examScore/', method: 'put', params: { examId: e.id } });
            this.score = res2.data.exam;
            if(res2.data.questionExams){
                res2.data.questionExams.sort((a, b) => a.index-b.index);
            }
            this.examQuestions = res2.data.questionExams;
            this.parent.$set(this.results, e.id, res2.data);
            this.loading = false;
        }
        this.scheduleLogout();
    },
    async finishExam(){
     await  this.fetchResults();
        session.examIsFinished = true;
        sessionStorage.setItem("countDown", null);
        this.countDown=null;
        this.clearSessionStorage();
        this.examEnded = true;
        this.loading = false;
        this.prevQuestId = 0;
        this.startExam = false;
        this.data = null;
        if(this.parent){
            stopRecording(this.parent.$store);
        }
    },
    async saveCurrentQuestionAnswer(examQuestion) {
    if (!examQuestion) return;

    const params = {
        prevQuestId: this.fullExam ? examQuestion.question.id : this.prevQuestId,
        examId: this.fullExam ? examQuestion.exam.id : sessionStorage.getItem("ExamId"),
        currentAnswerChekedIds: this.currentAnswerChekedId[examQuestion.id] || [],
        user: null,
        index: this.fullExam ? examQuestion.index : this.data?.index,
        isSkiped: false,
        clientTime: new Date().toJSON(),
        timeElapsed: this.startDate ? (((new Date() - this.startDate) / 1000) | 0) : 0,
        haveAnyAnswer: (this.currentAnswerChekedId[examQuestion.id] || []).length > 0
    };

    return await axios({
        async: true,
        crossDomain: true,
        url: process.env.VUE_APP_ROOT_API + 'examNext/',
        method: 'put',
        data: params
    });
},
    async afterExamCall(res) {
        if (res.data == null) {
            const params = {
                examId: sessionStorage.getItem("ExamId")
            };
            try {
                await this.loadExam(this.groupId, this.fullExam);
                if (this.examEnded) {
                    this.finishExam();
                }
                else {
                    this.startExam = false;
                    this.prevQuestId = 0;
                }

            }
            catch (error) {
                this.clearSessionStorage();
            }
        }
        else {
            this.obs = null;
            sessionStorage.setItem("startExam", "true");
            this.startExam = true;
            this.data = res.data;
            this.countDown = this.data.remaining * 1000;
            this.startDate = new Date();
            if(this.fullExam){
                //replace the exam question with the returned one
                const examIndex = res.data.exam.index;
                const examQuestions =  this.exam.fullGroupExams[examIndex-1].examQuestions;
                const questionIndex = res.data.index;
                examQuestions[questionIndex-1] = res.data;
            }
            else{
                this.currentAnswerChekedId = {};
                this.currentAnswerChekedId[this.data.id]=[];
                this.data.exam.questionDisplayCount = this.data.index;
                this.data.answerExams.forEach((ans) => {
                    if (ans.isChecked)
                        this.currentAnswerChekedId[this.data.id].push(ans.id);
                });
                this.prevQuestId = this.data.question.id;
                
            }
            this.refreshBtns(false);
            this.loading = false;
        }

    },

    scheduleLogout(){
        if (session.isExamApp()) {
            if(!sessionStorage.getItem("logOutTimer")){
                sessionStorage.setItem("logOutTimer", setTimeout(() => {
                    session.logout();
                }, (15 * 60) * 1000));
            }
        }
    },

    checkAnswer(examQuestion,optionId, value) {
        if (this.data.answerType == 'cs')
            this.currentAnswerChekedId[examQuestion.id][0] = optionId;
        else {
            if (value)
                this.currentAnswerChekedId[examQuestion.id].push(optionId);
            else {
                let index = 0;
                do {
                    index = this.currentAnswerChekedId[examQuestion.id].indexOf(optionId);
                    if (index > -1) {
                        this.currentAnswerChekedId[examQuestion.id].splice(index, 1);
                    }
                } while (index > -1)


            }
        }
    },

    optionClicked(examQuestion, optionId, radioForSimple) {
        if (this.loading) {
            return;
        }
        if (examQuestion.answerType == 'CS' && radioForSimple)
            this.currentAnswerChekedId[examQuestion.id][0] = optionId;
        else {
            let index = this.currentAnswerChekedId[examQuestion.id].indexOf(optionId);
            if (index < 0) {
                this.currentAnswerChekedId[examQuestion.id].push(optionId);
            } else {
                do {
                    index = this.currentAnswerChekedId[examQuestion.id].indexOf(optionId);
                    if (index > -1) {
                        this.currentAnswerChekedId[examQuestion.id].splice(index, 1);
                    }
                } while (index > -1)
            }
        }
    },

    async checkDate() {
        if (sessionStorage.getItem("ExamId") > 0 || (sessionStorage.getItem("startExam") != null && sessionStorage.getItem("startExam"))) {
            this.loading = false;
           await this.getNextQuestion(-1,false);
        } else {

            axios({
                "async": true,
                "crossDomain": true,
                url: process.env.VUE_APP_ROOT_API + 'checkExam/',
                method: 'get',

            }).then((res) => {

                if (res.statusText == 'No Content') {
                    this.noExamRzv = true;
                    this.clearSessionStorage();
                } else {
                    if (res.data != null) {
                        if (res.data.status == 'Finished') {
                            this.exam = res.data;
                            this.loading = false;
                            this.noExamRzv = false;
                            this.examStatus = 'finished';
                            this.clearSessionStorage();
                        } else {
                            this.exam = res.data;
                            this.loading = false;

                            this.noExamRzv = false;

                            sessionStorage.setItem("ExamId", this.exam['id']);

                             this.getNextQuestion(-1,false);

                        }
                    }
                }
            }).catch(function (error) {
                this.clearSessionStorage();

            });
        }

    },

    async loadExam(groupId, fullExam = false) {
        this.fullExam = fullExam;
        this.groupId=groupId;
        this.loading = true;
            await axios({
                "async": true,
                "crossDomain": true,
                url: process.env.VUE_APP_ROOT_API + (fullExam ? 'fullExam' : 'getExamById/'),
                method: 'get',
                params: { groupId: groupId }

            }).then(async (res) => {

                if (res.statusText == 'No Content') {
                    this.noExamRzv = true;
                    this.clearSessionStorage();
                    this.examEnded = true;
                } else {
                    if (res.data != null) {

                        if(fullExam){
                            this.fullExams = res.data;
                            if(!res.data.fullGroupExams.find(x=>x.status!='Finished')){
                                this.exam = res.data;
                                //exam finished
                                console.log("Exam finished");
                                this.examEnded = true;
                                this.loading = false;
                                this.noExamRzv = false;
                                this.examStatus = 'finished';
                                this.fetchResults();
                                this.clearSessionStorage();
                            }else{
                                this.currentAnswerChekedId={};
                                res.data.fullGroupExams.forEach(e=>{
                                    e.examQuestions.forEach(eq=>{
                                        eq.exam={id :e.id}
                                        this.currentAnswerChekedId[eq.id]=[];
                                        eq.answerExams.forEach((ans) => {
                                            if (ans.isChecked)
                                                this.currentAnswerChekedId[eq.id].push(ans.id);
                                        });
                                    })
                                });
                                //exam not finised 
                                this.prevQuestId = 0;
                                this.exam = res.data;
                                this.currentExamIndex = 0;

                                this.noExamRzv = false;

                                sessionStorage.setItem("ExamId", this.fullExams.fullGroupExams[this.currentExamIndex].id);

                                await this.getNextQuestion(res.data.fullGroupExams[0].examQuestions[0], -1,false, true, false, true);
                                this.loading = false;
                            }
                        }
                        else{
                            if (res.data.status == 'Finished') {
                                this.examEnded = true;
                                this.exam = res.data;
                                this.loading = false;
                                this.noExamRzv = false;
                                this.examStatus = 'finished';
                                this.fetchResults();
                                this.clearSessionStorage();
                            } else {
                                this.prevQuestId = 0;
                                this.exam = res.data;
                                this.currentExamIndex = this.exam.index - 1;

                                this.noExamRzv = false;

                                sessionStorage.setItem("ExamId", this.exam['id']);

                                this.getNextQuestion(-1,false);
                                this.loading = false;

                            }
                        }
                    }
                }
                this.loading = false;
            }).catch((error) =>{
                console.error(error);
                this.clearSessionStorage();

            });

    },

    clearSessionStorage() {

        sessionStorage.removeItem("startExam");
    },
    updateQuestObs(value) {
        this.obs = value;
    },
    str_pad_left(string, pad, length) { return (new Array(length + 1).join(pad) + string).slice(-length); },
});
